<template>
<!-- 项目 - 预警设置配置和详情 -->
  <div class="set-box">
    <div class="conf-head">
      <p>事件预警配置</p>
      <p>
        <el-button v-if="type==1" @click="goBack">取消返回</el-button>
        <el-button v-if="type==1" type="primary" @click="submitForm">保存提交</el-button>
        <el-button v-if="type==0" type="primary" @click="goBack">返回</el-button>
      </p>
    </div>
    <div class="conf-con">
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item label="事件类型：">
          <span v-if="type==0">{{form.name}}</span>
          <el-select v-else v-model="form.type" placeholder="请选择">
            <el-option
              v-for="item in topicList"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="监测范围：">
          <el-input type="textarea" :rows="5" v-if="type==1" v-model="form.sidsName" readonly style="width:90%;min-height:40px;"></el-input>
          <el-button type="text" @click="showDialog" v-if="type==1" style="width:10%;text-align: right;">选择</el-button>
          <div style="min-height:6vh;" v-if="type==0">{{form.sidsName}}</div>
        </el-form-item>
        <el-form-item label="预警时间段：" v-if="type==0">
          <div v-for="(item,index) in curTimeList" :key="index" style="display: flex;">
            <div>
              <span style="display: inline-block;width: 10vw;padding: 0 1vw;">{{item.start}}</span>
                ~ 
              <span style="display: inline-block;width: 10vw;padding: 0 2vw;">{{item.end}}</span>
            </div>
            <p v-if="index==0" style="font-size:1.4vh;color:#999;">注：时间段设置后，只有此期间监测到的图像会生成预警，默认全天监测。</p>
          </div>
        </el-form-item>
        <el-form-item label="预警时间段：" v-else>
          <div class="time-first" v-for="(item,index) in curTimeList" :key="index">
            <div class="time-set" v-if="item.flag">
              <div>
                <el-time-picker
                  v-model="item.curStart"
                  value-format="HH:mm"
                  format="HH:mm"
                  placeholder="任意时间点">
                </el-time-picker>
                 ~ 
                <el-time-picker
                  v-model="item.curEnd"
                  value-format="HH:mm"
                  format="HH:mm"
                  placeholder="任意时间点">
                </el-time-picker>
              </div>
              <div>
                <el-button type="text" style="color:#797676;" @click="cancleFun(index,item)">取消</el-button>
                <el-button type="text" @click="saveFun(index,item)" >保存</el-button>
              </div>
            </div>
            <div class="time-set" v-else>
              <div>
                <span style="display: inline-block;width: 10vw;padding: 0 1vw;">{{item.start}}</span>
                 ~ 
                <span style="display: inline-block;width: 10vw;padding: 0 2vw;">{{item.end}}</span>
              </div>
              <div>
                <el-button type="text" @click="editTimeSlot(index,item)">编辑</el-button>
              </div>
            </div>
            <div>
              <el-button type="text" icon="el-icon-plus" @click="addTimeSlot" v-if="index==0">添加</el-button>
              <el-button type="text" icon="el-icon-minus" @click="delTimeSlot(index,item)" style="color:#CC66CC;" v-else>删除</el-button>
            </div>
          </div>
          <p style="font-size:1.4vh;color:#999;">注：时间段设置后，只有此期间监测到的图像会生成预警，默认全天监测。</p>
        </el-form-item>
        <el-form-item label="预警持续时间：">
          <div v-if="type==0" style="display:flex;">
            <p style="width:10vw;">{{form.warningDuration}} 分钟</p>
            <p style="font-size:1.4vh;color:#999;">注：设置后时间持续符合条件的事件会生成预警，默认0分钟。</p>
          </div>
          <div v-else>
            <el-input v-model="form.warningDuration"></el-input> 分钟
            <p style="font-size:1.4vh;color:#999;">注：设置后时间持续符合条件的事件会生成预警，默认0分钟。</p>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <!-- 新增窗口 -->
    <el-dialog
      title="设备选择"
      :visible.sync="deviceVis"
      center
      :append-to-body="true"
      :lock-scroll="false"
      width="40%"
    >
      <div class="dig-head">
        <el-input
          placeholder="请输入内容"
          suffix-icon="el-icon-search"
          style="height:4vh;width:50%;"
          @change="doFilter"
          v-model="deviceName">
        </el-input>
        <el-button type="primary" @click="submitDialogFun" style="float:right;margin-top:3.5vh;padding-left:2vw;padding-right:2vw;">确定</el-button>
      </div>
      <el-table
        :data="dialogData"
        height="300"
        ref="deviceTable"
        style="width: 100%"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="channelName"
          label="设备名称">
        </el-table-column>
        <el-table-column
          prop="sid"
          label="序列号">
        </el-table-column>
        <el-table-column
          prop="baseChannelId"
          label="通道号">
        </el-table-column>
        <el-table-column
          prop="remarks"
          label="备注">
        </el-table-column>
      </el-table>
      <!-- <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          style="text-align: right;"
          :total="totalItems"
      ></el-pagination> -->
    </el-dialog>
  </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
export default {
  data(){
    return{
      form:{
        name:'',
        warningDuration:'',
        // timeList:[ //后侧获取数据
        //   {start:'00:00',end:'23:59',flag:false},
        // ],
        sids:'',
        sidsName:''
      },
      groupId:'',
      curTimeList:[ //当前数据配置
        {start:'00:00',end:'23:59',flag:false,curStart:'',curEnd:''},
      ],
      deviceVis:false, //弹出框
      deviceName:'',//弹出框查询框
      dialogData:[],//弹出框列表
      //跳转
      currentPage:1,
      pageSize:10,
      totalItems:0,
      multipleSelection:[],//弹出框选中项
      id:'',
      type:'',//判断是否查看还是创建
      topicList:[],//事件列表
    }
  },
  mounted(){
    this.groupId = util.session.get('groupId')
    var params = this.$route.params
    this.type = params.type
    if(params.id && '0'!=params.id){
      this.id = params.id
      this.getConfInfo()
    }
    this.getTopicList()
  },
  methods:{
    //获取数据
    getConfInfo(){
      var that = this
      myHttp.selectProjectConfigCamera({
        projectId:this.groupId,
        type:that.id
      }).then(function(resp){
        if(resp.data.code=='200'){
          var data = resp.data.data.config
          that.form.type = that.id
          that.form.name = data.name
          that.form.sidsName = data.channelName
          that.form.sids = data.sid
          that.form.warningDuration = parseFloat(data.warningDuration)
          var times = data.time&&''!=data.time?JSON.parse(data.time):[]
          if(times.length>0){
            that.curTimeList = []
            for(var i=0;i<times.length;i++){
              times[i].flag = false
              times[i].curStart = times[i].start
              times[i].curEnd = times[i].end
            }
            that.curTimeList = times
          }
        }
      })
    },
    //展示弹出框
    showDialog(){
      this.deviceVis = true
      this.getDiaData();
    },
    //弹出框查询
    doFilter(){
      this.currentPage = 1
      this.getDiaData();
    },
    //
    // handleSizeChange(val){
    //     this.pageSize = val
    //     this.handleCurrentChange(this.currentPage)
    // },
    // handleCurrentChange(val){
    //     this.currentPage = val
    //     this.currentChangePage();
    // },
    // currentChangePage() {
    //     this.getDiaData();
    // },
    //弹出框获取数据
    getDiaData(){
      // this.$refs.deviceTable.toggleRowSelection(row);
      var that = this
      myHttp.selectProjectAiCameraList({
        name:this.deviceName,
        projectId:this.groupId
        // pageNum:this.currentPage,
        // pageSize:this.pageSize
      }).then(function(resp){
        if(resp.data.code=='200'){
          var list = resp.data.data.aiEquipCameras||[]
          that.dialogData = list
          setTimeout(function(){
            if(that.id &&''!=that.id){
              for(var i=0;i<list.length;i++){
                if(that.filterDevice(list[i].sid)){
                  that.$refs.deviceTable.toggleRowSelection(list[i]);
                }
              }
            }
          },0)
          //that.totalItems = resp.data.data.aiEquipCameras.total||0
        }
      })
    },
    //判断是否选中
    filterDevice(id){
      var result = false
      var list = this.form.sids&&''!=this.form.sids?this.form.sids.split(','):[]
      for(var i=0;i<list.length;i++){
        if(list[i]==id){
          result = true
        }
      }
      return result
    },
    //弹出框列表多选框
    handleSelectionChange(val){
      // console.log(val)
      this.multipleSelection = val;
    },
    //弹出框点击确定
    submitDialogFun(){
      var list = this.multipleSelection
      var name = ''
      var sids = ''
      for(var i=0;i<list.length;i++){
        name = name==''?list[i].channelName:name+','+list[i].channelName
        sids = sids==''?list[i].sid:sids+','+list[i].sid
      }
      this.form.sidsName = name
      this.form.sids = sids
      this.deviceVis = false
    },

    //添加时间段
    addTimeSlot(){
      var obj = {start:'',end:'',flag:true,curStart:'',curEnd:''}
      this.curTimeList.push(obj)
    },
    //删除时间段
    delTimeSlot(index,row){
      this.curTimeList.splice(index,1)
    },
    //编辑时间段
    editTimeSlot(index,row){
      this.curTimeList[index].curStart = this.curTimeList[index].start
      this.curTimeList[index].curEnd = this.curTimeList[index].end
      this.curTimeList[index].flag = true
    },
    //取消修改
    cancleFun(index,row){
      this.curTimeList[index].curStart = this.curTimeList[index].start
      this.curTimeList[index].curEnd = this.curTimeList[index].end
      this.curTimeList[index].flag = false
    },
    //保存修改
    saveFun(index,row){
      this.curTimeList[index].start = this.curTimeList[index].curStart
      this.curTimeList[index].end = this.curTimeList[index].curEnd
      this.curTimeList[index].flag = false
    },
    //获取事件列表
    getTopicList(){
      var that = this
      myHttp.getTopicValueList().then(function(resp){
        if(resp.data.code=="200"){
            var list = resp.data.data.aiEquipCameraTopics||[];
            list.push({
              createDate: null,
              id: "7",
              name: " 未穿反光衣",
              topic: "icmid-belt-msg",
              updateDate: null,
              value: "7",
            })
            list.push({
              createDate: null,
              id: "8",
              name: " 吸烟",
              topic: "icmid-belt-msg",
              updateDate: null,
              value: "8",
            })
            list.push({
              createDate: null,
              id: "9",
              name: " 跌倒",
              topic: "icmid-belt-msg",
              updateDate: null,
              value: "9",
            })
            that.topicList = list;
            
        }else{
          that.$message.error(resp.data.msg);
        }
      },function(){});
    },
    //保存
    submitForm(){
      // console.log(this.form)
      // console.log(this.curTimeList)
      var that = this
      var time = []
      for(var i=0;i<this.curTimeList.length;i++){
        var obj = {start:this.curTimeList[i].start,end:this.curTimeList[i].end}
        time.push(obj)
      }
      this.form.projectId = this.groupId
      this.form.time = JSON.stringify(time)
      //if(this.id==''){
        this.form.createBy = util.session.get('user').id
        myHttp.createOrUpdateInfoAndCamera(this.form).then(function(resp){
          if(resp.data.code=='200'){
            that.$message.success(resp.data.msg);
            that.$router.go(-1)
          }else{
            that.$message.error(resp.data.msg);
          }
        })
      //}
    },

    //返回
    goBack(){
      this.$router.go(-1)
    },

  },

}
</script>

<style scoped>
    .set-box{
      width: 100%;
      height: 100%;
      position: relative;
      background: #fff;
      padding: 1vh;
      
    }
    .set-box *,.set-box .el-form-item__label{
      font-size: 1.8vh;
    }
    .conf-head{
      width: 100%;
      height: 10vh;
      position: relative;
      padding: 0 1vw;
      display: flex;
      align-content: center;
      align-items: center;
      justify-content: space-between;
    }
    .conf-con{
      width: 60%;
      min-width: 32vw;
      height: calc( 100% - 11vh );
      position: relative;
      overflow: auto;
      padding-left: 2vw;
    }
    .time-first{
      width:100%;
      height:6vh;
      margin-bottom:2.5vh;
      display:flex;
      justify-content: space-between;
      align-content: center;
      align-items: center;
      position: relative;
      /* padding: 0 1vw; */
    }
    .time-set{
      width: 90%;
      height: 100%;
      background: #f2f2f2;
      position: relative;
      display:flex;
      justify-content: space-between;
      align-content: center;
      align-items: center;
      position: relative;
      padding: 0 1vw;
    }


    .dig-head{
      width: 100%;
      height: 9vh;
      position: relative;
      /* display: flex; */
      padding: 0 1vw;
      /* justify-content: space-between; */
    }
    
</style>

<style>
  @import '../../../assets/css/common.css';
  .set-box .el-form-item__content{
    text-align: left;
  }
  /* .dig-head .el-input__inner{
      height: 100%;
    } */
</style>